module.exports = __webpack_public_path__ + "img/fire_truck_h.6eaff281.png";